export default "__VITE_ASSET__CuwgU9pb__"